import { gql } from '@apollo/client';

export const LIST_ELIGIBLE_SHIPPING_METHODS = gql`
  fragment ShippingMethodFragment on ShippingMethodDefinition {
    category
    type
    code
    tmsCode
    configuration {
      aboveAllThresholdsAmount
      cartTotalThreshold
      thresholds {
        threshold
        underThresholdAmount
      }
    }
  }

  query listEligibleShippingMethods($shippingAddress: IBaseAddress!) {
    listEligibleShippingMethods(shippingAddress: $shippingAddress) {
      ...ShippingMethodFragment
    }
  }
`;
